import { API } from 'api';
import { CameraTimeLapseFrameDetails } from 'features/cameras/cameras.types';

export const fetchCameraTimeLapse = async (
  compositeId: string,
  replayTime: string,
): Promise<CameraTimeLapseFrameDetails[]> => {
  const response = await API.get<CameraTimeLapseFrameDetails[]>(
    `/cameras_gis/timelapse/${compositeId}`,
    { params: { duration: replayTime } },
  );
  return response.data;
};
